import { InAppMessageScheduleRequest } from "../InAppMessageScheduleRequest"
import { InAppMessageScheduleResponse } from "../InAppMessageScheduleResponse"
import { InAppMessageScheduleAction } from "../action/InAppMessageScheduleAction"
import { InAppMessageScheduler } from "./InAppMessageScheduler"
import { InAppMessageScheduleType } from "../InAppMessageScheduleType"

export abstract class AbstractInAppMessageScheduler implements InAppMessageScheduler {
  protected abstract deliver(request: InAppMessageScheduleRequest): Promise<InAppMessageScheduleResponse>
  protected abstract delay(request: InAppMessageScheduleRequest): Promise<InAppMessageScheduleResponse>
  protected abstract ignore(request: InAppMessageScheduleRequest): Promise<InAppMessageScheduleResponse>

  /**
   * @override
   */
  abstract supports(scheduleType: InAppMessageScheduleType): boolean

  /**
   * @override
   */
  schedule(
    action: InAppMessageScheduleAction,
    request: InAppMessageScheduleRequest
  ): Promise<InAppMessageScheduleResponse> {
    switch (action) {
      case "DELIVER":
        return this.deliver(request)
      case "DELAY":
        return this.delay(request)
      case "IGNORE":
        return this.ignore(request)
    }
  }
}
